// Société courante, persistée en sessionStorage ; évènement custom (hors redux) pour notifier logo/libellé sans reload
export const SOCIETE_EN_COURS_CHANGE_EVENT = "societe-en-cours-change";

const SOCIETE_EN_COURS_KEY = "societeEnCours";

export function getSocieteEnCours(): string {
  return sessionStorage.getItem(SOCIETE_EN_COURS_KEY) ?? "";
}

export function setSocieteEnCours(code: string) {
  sessionStorage.setItem(SOCIETE_EN_COURS_KEY, code);
  window.dispatchEvent(new CustomEvent(SOCIETE_EN_COURS_CHANGE_EVENT));
}
